import { t } from 'i18next';
import { Bar } from '../../../shared/components/bar';
import { GraphicFrame } from '../../../shared/components/graphic-frame';

// Decorative preview for the assignment step (parent GraphicFrame is aria-hidden).
export function AssignmentGraphic() {
  return (
    <GraphicFrame>
      <div className="flex h-full flex-col justify-center gap-5 px-4 py-4">
        <div className="flex items-center gap-4">
          <div className="flex flex-none items-center">
            <span className="relative z-10 grid size-11 place-items-center rounded-xl bg-platform-primary text-white ring-[3px] ring-white">
              <TagGlyph />
            </span>
            <span className="z-0 -ms-3.5 grid size-11 place-items-center rounded-xl bg-gray-100 bg-surface-sunken text-text-secondary">
              <UsersGlyph />
            </span>
          </div>
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <Bar className="h-2 w-[80%]" />
            <Bar tone="muted" className="h-2 w-[54%]" />
          </div>
        </div>

        <div className="flex items-center gap-2.5 rounded-xl bg-platform-primary/10 px-4 py-3">
          <CheckCircleGlyph />
          <span className="font-bold text-[13px] text-platform-primary">
            {t('features:onboarding.components.price_list_assignment_preview.assigned')}
          </span>
          <span className="ms-auto flex h-6 shrink-0 items-center rounded-full bg-platform-primary px-3 font-bold text-[11px] text-white">
            −20%
          </span>
        </div>
      </div>
    </GraphicFrame>
  );
}

function TagGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="size-5"
      aria-hidden="true"
    >
      <path d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.1 18.1 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
      <path d="M6 6h.008v.008H6V6Z" />
    </svg>
  );
}

function UsersGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="size-5"
      aria-hidden="true"
    >
      <path d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.32 12.32 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
    </svg>
  );
}

function CheckCircleGlyph() {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className="size-4.5 shrink-0 text-platform-primary"
      aria-hidden="true"
    >
      <path d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
    </svg>
  );
}
